<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/po">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading.page" class="margin-bottom">
            <div slot="title">
              Addendum Manifest
              <small class="m-display-block m-text-small">{{
                data.manifest.no_adendum
              }}</small>
            </div>
            <template slot="extra">
              <a-popover v-model="visiblemenupopover" trigger="click" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li v-if="getAuth.username == data.manifest.user_creator">
                      <a-button
                        :disabled="
                          !(
                            data.last_status == 'Revised' &&
                            getAuth.username == data.manifest.user_creator
                          )
                        "
                        type="dashed"
                        icon="edit"
                        class="width-full"
                        @click="handleEdit(data.manifest.id_manifest,data.manifest.jenis_transaksi)"
                        >Edit</a-button>
                      <a-button
                        :disabled="
                          !(
                            data.last_status == 'Revised' &&
                            getAuth.username == data.manifest.user_creator
                          )
                        "
                        type="dashed"
                        icon="close-square"
                        class="width-full margin-top"
                        :loading="loading.cancel"
                        @click="handleCancelTrans()"
                      >Cancel</a-button>
                  </li>
                </ul>
                <a-button icon="more">Action</a-button>
              </a-popover>
            </template>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.date_created
                        ? moment(
                            data.manifest.date_created,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.manifest.user_creator
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No PO / WO</span>
                  <span class="m-list-desc">{{ data.manifest.no_transaksi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Supplier</span>
                  <span class="m-list-desc">{{ data.manifest.supplier }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No Invoice / No Tracking</span>
                  <span class="m-list-desc">{{ data.manifest.no_invoice }} / {{ data.manifest.no_tracking }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Invoice Date</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.invoice_date
                        ? moment(
                            data.manifest.invoice_date,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Due Date</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.due_date
                        ? moment(
                            data.manifest.due_date,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-card :loading="loading.action" class="margin-bottom">
            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Account Number</span>
                  <span class="m-list-desc">{{ data.manifest.account_number }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency From</span>
                  <span class="m-list-desc">{{ data.manifest.currency_from }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency To</span>
                  <span class="m-list-desc">{{ data.manifest.currency_to }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Exchange Rate {{ data.manifest.currency_from }} to {{ data.manifest.currency_to }}</span>
                  <span class="m-list-desc">{{ data.manifest.exchange_rate }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value Addendum</span>
                  <span class="m-list-desc">{{ formatCurrency(data.manifest.currency_to,data.manifest.value_adendum) }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>File Document</span>
                  <span class="m-list-desc">
                    <a-button icon="eye" @click="handleViewDoc()" size="small" class="margin-top">
                      View Document
                    </a-button>
                  </span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-collapse
            class="margin-top"
            activeKey="1"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Detail Addendum</h4>
                <!-- <div>
                  <a-button
                    @click="toKodeSetoran"
                    type="default"
                    class="margin-right-small"
                    size="small"
                    v-if="isTaxOfficer"
                  >
                    Kode Setoran Pajak
                    <a-icon type="upload" />
                  </a-button>
                </div> -->
              </div>
              <a-input-search
                  v-model="search"
                  placeholder="Quick Search"
                  allowClear
                  :change="searching"
                  class="margin-bottom"
                />
                <a-table
                  :rowKey="(record, index) => {return index;}"
                  :columns="columns"
                  :dataSource="data.dtl_manifest"
                  :pagination="pagination"
                  size="small"
                  bordered
                  :scroll="{ x: 950 }"
                >
                  <span slot="no" slot-scope="text, data, index">
                    {{index+1}}
                  </span>
                  <span slot="item" slot-scope="item">
                    <b>{{ item.item_name }}</b
                    ><br />
                    <i>({{ getLabelTax(item.type_tax ? item.type_tax : item.tax_type) }})</i>
                  </span>
                  <span slot="ppdtl" slot-scope="ppdtl">
                    {{ ppdtl.pp_detail }}<br />
                    <i> {{ ppdtl.kode_anggaran }}</i>
                  </span>
                  <span slot="values" slot-scope="item">
                    <CurrencyJustified
                      :currencyValue="data.manifest.currency_to"
                      :valueNumber="item.values"
                    />
                  </span>
                  <span slot="total_values" slot-scope="item">
                    <CurrencyJustified
                      :currencyValue="data.manifest.currency_to"
                      :valueNumber="(item.values*item.quantity)"
                    />
                  </span>
                  <span slot="doc_tax" slot-scope="item">
                    <div style="text-align: center;">
                      <a-button 
                        v-if="item.is_tax=='1' && item.tax_type != 'bea_masuk'"
                        icon="edit" 
                        size="small" 
                        :type="item.kode_setoran_pajak!=null && item.kode_setoran_pajak!=null ? 'primary' : 'danger'" 
                        style="margin-right:5px"
                        @click="handleShowTaxModal(item)"
                        :disabled="!(data.jenis=='Verifikator' &&  item.is_tax =='1' && item.tax_type !='bea_masuk')"
                        >
                      </a-button>

                      <a-button icon ="file" disabled size="small" v-if="item.is_tax =='1' && item.document_tax=='No File Uploaded'" >
                      </a-button>
                      <a-button icon ="file" @click="handleViewDocLink(item)" size="small" v-if="item.is_tax =='1' && item.document_tax!='No File Uploaded'">
                      </a-button>
                    </div>
                  </span>
                </a-table>
            </a-collapse-panel>
          </a-collapse>

          <a-card class="margin-top" v-if="data.jenis === 'Transfer' && status_transfer">
            <div slot="title">Manifest Actions
              &nbsp;<i v-if="data.jenis=='Transfer' && !status_transfer" style="color:red!important">(Funding has not been set)</i>
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(currency_tf, sisa_tf)
                }}</a-tag>
            </div>
            <template v-if="!(data.jenis=='Transfer' && !status_transfer)">
              <a-form :form="form">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                            @change="onChangeStatus"
                            v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                            placeholder="Select Date"
                            :format="dateFormat"
                            v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                            :fileList="fileList"
                            :disabled="fileList.length > 0"
                            v-decorator="[
                        'file_transfer',
                        { rules: [{ required: reqFileTf }] },
                      ]"
                            accept=".jpg, .png, .pdf"
                            :remove="handleRemove"
                            :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                            :defaultChecked="true"
                            @change="onchangeNilaiTf"
                            :checked="checkTransferValue"
                    >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                            :min="0.1"
                            :max="sisa_tf"
                            class="m-display-block"
                            v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                            :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                            placeholder="Write the note here ... "
                            :rows="4"
                            v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                          @click="handleActionConfirm"
                          block
                          type="primary"
                          html-type="submit"
                  >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card>

          <a-card
            class="margin-top"
            :loading="loading.action"
            v-if="data.jenis === 'Verifikator' || data.jenis === 'Approve'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                  v-decorator="[
                    'aksi',
                    {
                      rules: [{ required: true }],
                      initialValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option
                    v-for="item in data.aksi"
                    :key="item.aksi"
                    >{{ item.aksi }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>

        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transfer Receipt</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li
                  v-for="(dbt, index) in data.detailBuktiTransfer"
                  :key="index"
                >
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      {{ dbt.tgl_tf }} | {{ dbt.user_tf }}
                    </h4>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                  <div class="m-display-flex space-between align-middle">
                    <p slot="description">
                      {{ dbt.currency + ". " + dbt.value_tf }}
                    </p>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.manifest.date_created).format(
                          getDateTimeFormat
                        )
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.manifest.catatan">{{
                      data.manifest.catatan
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="
              data.jenis === 'Manifest' ||
                data.jenis === 'Verifikator' ||
                data.jenis === 'Transfer'
            "
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Account Pay</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.ap">
                <Empty v-if="data.ap ? data.ap.length <= 0 : data.ap" />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <span class="margin-remove m-text-dots">
                        {{ item.no_ap ? item.no_ap : "-" }}
                      </span>
                      <a-button
                        @click="handleViewFile(item)"
                        icon="eye"
                        size="small"
                        >View</a-button
                      >
                    </div>
                    <div slot="description">
                      <a-row>
                        <a-col span="6">No Invoice</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.no_invoice }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Due Date</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.due_date }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Value</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{
                          formatCurrency(data.manifest.currency, item.value)
                        }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Catatan</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.catatan }}</a-col>
                        <!-- <Status :status="item.status_bkk" /> -->
                      </a-row>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="
              data.jenis === 'Manifest' ||
                data.jenis === 'Verifikator' ||
                data.jenis === 'Transfer'
            "
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button
                    @click="addLampiran"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.lampiran">
                <Empty
                  v-if="
                    data.lampiran ? data.lampiran.length <= 0 : data.lampiran
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title">
                      <a
                        @click="handleDownload(item)"
                        class="margin-remove m-text-dots"
                      >
                        {{ item.jenis ? item.jenis : "-" }}
                      </a>
                    </div>
                    <div slot="description">
                      <div class="m-display-flex space-between nowrap">
                        <h4 class="margin-remove m-text-dots">
                          {{ item.fungsi }}
                        </h4>
                        <a-button
                          v-if="data.manifest.user_creator === getAuth.username"
                          @click="handleRemoveExisting(item.id_adendum_doc)"
                          size="small"
                          type="danger"
                          icon="delete"
                        ></a-button>
                      </div>
                      {{ item.tanggal }} | {{ item.tlc }}
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleViews(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="
                        item.estimated_value && item.rest_api !== 'supplier'
                      "
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.estimated_value)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
    >
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachments
      </span>

      <a-form :form="formLampiran">
        <a-form-item label="Document Type">
          <a-select v-decorator="['jenis', { rules: [{ required: true }] }]">
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Document Description">
          <a-input
            autocomplete="off"
            v-decorator="['fungsi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Upload Document File">
          <a-upload
            :remove="handleRemoveModal"
            v-decorator="[
              'file_list_lampiran',
              { rules: [{ required: true }] },
            ]"
            :fileList="fileListModalLampiran"
            :showUploadList="true"
            :disabled="fileListModalLampiran.length > 0"
            :beforeUpload="beforeUploadModal"
          >
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleUploadLampiran"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <TaxDepositEntry 
      :v-if="visibleTaxModal" 
      :visibleTaxModal="visibleTaxModal" 
      :getType_tax="getType_tax"
      :getListsetoranpajak="datapajak.getListsetoranpajak"
      :getListobjekpajak="datapajak.getListobjekpajak"
      :tax_type="datapajak.tax_type"
      :file_document_tax="datapajak.file_document_tax"
      :kode_setoran_pajak="datapajak.kode_setoran_pajak"
      :objek_pajak="datapajak.objek_pajak"
      :id_header="datapajak.id_header"
      :id_dtl="datapajak.id_dtl"
      :dpp_value="datapajak.dpp_value"
      :value="datapajak.value"
      :file="datapajak.fileList"
      jenis_transaksi="adendum"
      :hideUploadDocTax="true"
      />
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "AddendumManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
    TaxDepositEntry,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      notfound: { animationData: notfound, loop: true },
      previewVisible: false,
      previewImage: "",
      loading: {
        page:false,
        cancel:false,
        action:false,
      },
      visibleHistory: false,
      visibleLampiran: false,
      visiblePop: false,
      visibleShipmentStatus: false,
      visibleShipmentDeliver: false,
      visibleShipmentReceive: false,
      visibleShipmentReceiveManifest: false,
      visibleDpo: false,
      modalListDpo: [],
      fileListLampiran: [],
      fileListModalLampiran: [],
      fileList: [],
      fileListModal: [],
      reqFileTf: true,
      disableNilaiTf: true,
      data: {
        detail_pembelian: [],
        dokumen_terkait: [],
        detailBuktiTransfer: [],
        manifest: {},
        status: [],
        history: [],
        total: {
          subTotal: "",
          grandTotal: "",
          nilaiPajak: "",
        },
        dokumen_butuh: [],
        lampiran: [],
        jenis: "",
        aksi: [],
        setoran_pajak:[],
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      pajak: "",
      dateFormat: "DD MMMM YYYY",
      tlc: "",
      cek_value: 1,
      sisa_tf: "",
      temp_sisa_tf: "",
      temp_gudang_id: "",
      penerimaan: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 19 },
        },
      },
      currency: "",
      printLoad: {
        manifest: false,
        cancel: false,
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      status_shipment: [],
      dataShipmentDeliver: [],
      dataShipmentReceive: [],
      dataShipmentManifestDetail: [],
      dataShipmentManifestHeader: [],
      tempDataReceive: [],
      clickedPop: false,
      cacheData: {},
      btnShipment: {},
      dataDetailShipment: {},
      daftarGudang: {},
      checkTransferValue: true,
      allowEditModal: false,
      editGudangVal: undefined,
      usedfor: "gudang",
      editTlcVal: undefined,
      visibleEditDtl: false,
      enabledEditDtl: false,
      editReceiveDtl: {
        title: "",
        key: "",
        qty: 0,
        tlc: "",
        tlc_name: "",
        opsi: "gudangreceive",
        idgudang: "",
        gudang_name: "",
      },
      dtabel: [],
      dtemptabel: [],
      dlist: [],
      status_transfer: false,
      visiblemenupopover: false,
      visibleTaxModal:false,
      datapajak: {
        getListsetoranpajak:{},
        getListobjekpajak:{},
        tax_type:"",
        file_document_tax:null,
        kode_setoran_pajak:"",
        objek_pajak:"",
        id_header:"",
        id_dtl:"",
      },
      currency_tf: "IDR",
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KURIR");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.$store.dispatch("Fetch_TYPE_TAX");
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
    this.formShipmentStatus = this.$form.createForm(this);
    this.formShipmentDeliver = this.$form.createForm(this);
    this.formDpo = this.$form.createForm(this);
    this.formShipmentReceive = this.$form.createForm(this);
    this.formSetReceive = this.$form.createForm(this);
    this.formeditRowDtl = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getAllGudang",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStatusShipment",
      "getAllKurir",
      "getAllKaryawan",
      "getType_tax",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          width: 65,
          align:"center",
          scopedSlots: { customRender: "no" },
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Values",
          key: "values",
          scopedSlots: { customRender: "values" },
          width: 100,
        },
        {
          title: "Total Values",
          key: "total_values",
          scopedSlots: { customRender: "total_values" },
          width: 100,
        },
      ];

      if (this.isTaxOfficer) {
        kolom.push({
          title: "Tax Deposit",
          key: "doc_tax",
          fixed: "right",
          scopedSlots: { customRender: "doc_tax" },
          width: 100,
        },);
      }
      return kolom;
    },
    getLastStatusShipment() {
      if (this.status_shipment) {
        if (this.status_shipment.length !== 0) {
          if (
            this.status_shipment[this.status_shipment.length - 1].deli_sts ===
            "Received"
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getMainStatus() {
      if (this.data.status.length !== 0) {
        return this.data.status[this.data.status.length - 1].status;
      }
    },
    getShippingflag() {
      return this.data.shipping_flag;
    },
    searching() {
      if (this.search) {
        this.data.dtl_manifest = this.data.dtl_manifestOri.filter(
          (obj) =>
            obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.data.dtl_manifest = this.data.dtl_manifestOri;
      }
      return true;
    },
    isTaxOfficer(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Tax Officer");
      return data.length>0 ? true : false;
    },
    isValidTaxOfficerValue(){
      let data = _.filter(this.data.dtl_manifestOri,(obj) => obj.is_tax=="1" && obj.kode_setoran_pajak==null && obj.tax_type !='bea_masuk');
      return data.length>0 ? false : true;
    }
  },
  methods: {
    ...mapActions(["FETCH_ALL_KURIR"]),
    moment,
    fetchManifest() {

      this.loading.page = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "addendum",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            ap: response.data.account_pay,
            currency: response.data.currency,
            manifest: response.data.data_manifest[0],
            dtl_manifest: response.data.dtl_manifest,
            dtl_manifestOri: response.data.dtl_manifest,
            dokumen_butuh: response.data.document,
            status: response.data.status_app,
            history: response.data.notifikasi,
            dokumen_terkait: response.data.dokumen_terkait,
            lampiran: response.data.lampiran,
            jenis: response.data.jenis,
            aksi: response.data.aksi,
            detailBuktiTransfer: response.data.bukti_transfer,
            purchasing: response.data.purchasing,
            last_status: response.data.status_besar,
            setoran_pajak: response.data.setoran_pajak,
            objek_pajak: response.data.objek_pajak,
            // shipping_flag: response.data.shipping_flag,

            // revised_flag: response.data.header.revised_flag == "1" ? true : false,
          };
          this.pajak = response.data.pajak;
          this.tlc = this.getAuth.username;
          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;
          this.penerimaan = response.data.penerimaan;
          this.currency = response.data.currency;
          this.currency_tf = response.data.currency_tf
          this.status_transfer = response.data.status_transfer;

          let dbt = this.data.detailBuktiTransfer;
          for (const [i, val] of dbt.entries()) {
            let name = i + 1 + val.url.substring(val.url.lastIndexOf("."));
            this.data.detailBuktiTransfer[i]["fileList"] = [
              {
                url: process.env.VUE_APP_SERVICEURL + val.url,
                uid: i,
                name: name,
                status: "done",
              },
            ];
            // this.data.tgl_bukti_transfer.push(moment(val.tgl_tf).format(this.data.dateFormatTf));
          }

          this.dtabel = [];
          this.dtemptabel = [];
          this.dlist = [];
          this.loading.page = false;
          let tempdtl = response.data.detail;
          for (let index = 0; index < tempdtl.length; index++) {
            const element = tempdtl[index];
            if (tempdtl[index].kategori == "0") {
              this.dtabel.push(element);
              this.dtemptabel.push(element);
            } else {
              this.dlist.push(element);
            }
          }

        })
        .catch((err) => {
          if (!err.response) {
            // let responses = Object.assign({}, err.response.data);
            // this.displayMessageValue("error", responses);
            // this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading.page = false;
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },

    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },


    cancelLampiran() {
      this.fileListModalLampiran = [];
      this.formLampiran.resetFields();
    },

    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "addendum/lampiran",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go()
            // this.$router.go()
            // const route = this.$router.resolve({
            //   name: this.$route.name,
            //   params: { id: this.id },
            // });
            // window.open(route.href, "_blank");
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileListModal.push(file);
        } else {
          this.fileListModalLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    handleRemoveModal(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileListModal.indexOf(file);
        const newFileList = this.fileListModal.slice();
        newFileList.splice(index, 1);
        this.fileListModal = newFileList;
      } else {
        const index = this.fileListModalLampiran.indexOf(file);
        const newFileList = this.fileListModalLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListModalLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },

    handlePreview(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(file.url, "_blank");
      } else {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },

    handleDownload(item) {

      // if (item.source === "simfoni") {
      window.open(this.$serviceUrl + item.link, "_blank");
      // } else {
      //   window.open(item.link, "_blank");
      // }
    },

    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },

    // metede template dari vue antd
    edit(key) {
      this.cacheData = this.tempDataReceive.map((item) => ({ ...item }));
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      this.editGudangVal = target.gudang_id;
      this.editTlcVal = target.tlc;

      if (target) {
        target.edit = true;
        target.editable = true;
        this.tempDataReceive = newData;
        // this.fullName = newData;
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.tempDataReceive = newData;
      }
    },
    handleSelected(value, key, column, index) {
      if (value === undefined) {
        const newData = [...this.tempDataReceive];
        const target = newData.filter((item) => key === item.key)[0];
        if (target) {
          // target[column] = dataFilter[0].gudang_nm;
          target["gudang_id"] = null;
          target["gudang_name"] = null;
          target["tlc"] = null;
          target["tlc_name"] = null;
          this.tempDataReceive = newData;
        }
      } else {
        if (this.usedfor === "gudang") {
          let dataFilter = this.getAllGudang.filter(
            (obj) =>
              obj.gudang_id.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].gudang_nm;
            target["gudang_id"] = value;
            this.tempDataReceive = newData;
          }
        } else {
          let dataFilter = this.getAllKaryawan.filter(
            (obj) => obj.tlc.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].tlc_nm;
            target["tlc"] = value;
            this.tempDataReceive = newData;
          }
        }
      }
    },
    cancel(key) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        target.edit = false;
        this.tempDataReceive = newData;
      }
    },
    save(key) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.edit = false;
        delete target.editable;
        this.tempDataReceive = newData;
      }
    },
    getDataReceivePost(val) {
      this.tempDataReceive = val.map((item, index) => {
        return {
          key: item.id_dtl,
          no: index + 1,
          item_pn: item.item_pn,
          kd_anggaran: item.kode_anggaran,
          dtl_pp_nm: item.nama_dtl_pp,
          item_name: item.nama_barang,
          quantity: item.jumlah,
          satuan: item.satuan,
          gudang_name: null,
          gudang_id: null,
          tlc_name: null,
          tlc: null,
          edit: false,
        };
      });
    },

    openWindowCopy(link, noResi) {
      const me = this;
      this.$copyText(noResi).then(
        function(e) {
          // this.displayMessageValue("success-copy-resi",e.text);
          me.displayMessageValue("success-copy-resi", e.text);
          window.open(link, "_blank");
        },
        function(e) {
          alert("Can not copy");
        }
      );
    },
    handleSelectedStorage(val) {
      if (val !== undefined) {
        this.tempDataReceive.map((item) => {
          item.gudang_id = val.key;
          item.gudang_name = val.label;
        });
        this.allowEditModal = true;
        this.enabledEditDtl = true;
      } else {
        this.tempDataReceive.map((item) => {
          item.tlc = undefined;
          item.tlc_name = undefined;
          item.gudang_id = undefined;
          item.gudang_name = undefined;
        });
        this.allowEditModal = false;
        this.enabledEditDtl = false;
      }
    },

    handleViews(val) {
      if (val.rest_api === "supplier") {
        let namemanifest = null;
        if (this.getNavigation[0].divisi === "Akuntansi") {
          namemanifest = "SpclSupplierManifestAcc";
        } else {
          namemanifest = "manifestPurchasing";
        }
        this.$router.push({
          name: namemanifest,
          params: {
            id: val.id_manifest,
            tlc: this.getAuth.username,
            user_pembuat: val.user_pembuat,
          },
        });
      } else {
        this.handleView(val);
      }
    },

    handleEdit(id,jns_transaksi) {
      this.$router.push({
        name: "editAddendum",
        params: { id: id, jenis_transaksi: jns_transaksi },
      });
    },
    handleRemoveLampiran(item) {
      this.loading.page = true;
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      Axios({
        method: "delete",
        url: serviceUrl + "addendum/lampiran",
        processData: false,
        data: {
          id_addendum_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.loading.page = false;
          Event.$emit("refresh", true);
          this.displayMessage("success-del");
        })
        .catch((err) => {
          this.loading.page = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    onChangeStatus(val){
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    handleActionConfirm(){
      let sts = this.form.getFieldValue("aksi");
      if(sts=='Verified' && this.isValidTaxOfficerValue){
        this.confirmMessage("confirm-save");
      }else if (sts!=='Verified'){
        this.confirmMessage("confirm-save");
      }else{
        this.displayMessageValue("error-other", "There is still Document Tax data that hasn't been filled in!");
      }
    },
    handleAction() {
      if (this.data.jenis === "Transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          let formData = new FormData();
          formData.append("tlc", this.getAuth.username);
          formData.append("id_manifest", this.id);
          formData.append("file_transfer", values.file_transfer.file);
          formData.append("remark", values.catatan);
          formData.append("status", 'Transferred');
          formData.append("tgl_transferan",  moment(values.tgl_tf).format(this.getStandartFormatDate));

          if(this.checkTransferValue){
            formData.append("cek_value", 1);
            formData.append("value_transferan", 0);
          }else{
            formData.append("cek_value", 0);
            formData.append("value_transferan", values.value_transferan);
          }

          this.loading.action = true;
          Axios({
            method: "post",
            url: this.$serviceUrl + "addendum/approval",
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
                  .then((response) => {
                    this.displayMessage("success");
                    this.$router.go(0);
                  })
                  .catch((err) => {
                    this.loading.action = false;
                    console.log("error : " + err);
                    let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
                  });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "addendum/approval",
            processData: false,
            data: {
              id_manifest: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              /* this.$router.push({ name: "po" }); */
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        });
      }
    },
    handleViewFile: function(item) {
      const data = {
        id_manifest: item.id_account_pay,
        rest_api: "accountpay",
      };
      this.handleView(data);
    },
    handleViewDoc() {
      window.open(this.$serviceUrl + this.data.manifest.file_path);
    },
    handleViewDocLink(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    toKodeSetoran(e){
      e.stopPropagation();
    },
    getLabelTax(val){
      let result = _.filter(this.getType_tax,(item) => item.value==val);
      return result.length>0 ? result[0].text : "Non Tax";
    },
    async handleShowTaxModal(item){
      this.datapajak.tax_type=item.tax_type;
      this.datapajak.kode_setoran_pajak=item.kode_setoran_pajak;
      this.datapajak.objek_pajak=item.kode_objek_pajak;
      this.datapajak.id_header=item.adendum_id;
      this.datapajak.id_dtl=item.adendum_id_dtl;
      this.datapajak.dpp_value=item.dpp_value;
      this.datapajak.value=item.tax_value;
      this.datapajak.getListsetoranpajak = _.filter(this.data.setoran_pajak,(obj)=> obj.id_type_tax == item.tax_type);
      this.datapajak.getListobjekpajak = _.filter(this.data.objek_pajak,(obj)=> obj.id_type_tax == item.tax_type);

      if (item.file_doc_tax!=null && item.file_doc_tax!="No File Uploaded"){
        let typefile = this.fileTypeFromUrl(item.file_doc_tax);
        let file = this.dataURLtoFile(typefile+item.document_file, item.file_doc_tax);
        file.uid= 'vc-upload-1-1';
        file.status= 'done';
        file.url= this.$serviceUrl+item.document_path;
        this.datapajak['fileList']=[];
        this.datapajak.fileList.push(file);
      }
      this.visibleTaxModal = true;
    },
    taxDepositEntryCancel(){
      this.visibleTaxModal = false;
    },
    taxDepositEntryUpdate(val){
      let index1 = _.findIndex(this.data.dtl_manifestOri, {adendum_id_dtl: val.id_dtl});
      this.data.dtl_manifestOri[index1].file_doc_tax = val.document_tax;
      this.data.dtl_manifestOri[index1].document_tax = val.document_tax;
      this.data.dtl_manifestOri[index1].document_path = val.document_path;
      this.data.dtl_manifestOri[index1].tax_value = val.tax_value;
      this.data.dtl_manifestOri[index1].kode_objek_pajak = val.objek_pajak;
      this.data.dtl_manifestOri[index1].kode_setoran_pajak = val.kode_setoran_pajak;
      let index2 = _.findIndex(this.data.dtl_manifest, {adendum_id_dtl: val.id_dtl});
      this.data.dtl_manifestOri[index2].file_doc_tax = val.document_tax;
      this.data.dtl_manifestOri[index2].document_tax = val.document_tax;
      this.data.dtl_manifestOri[index2].document_path = val.document_path;
      this.data.dtl_manifestOri[index2].tax_value = val.tax_value;
      this.data.dtl_manifestOri[index2].kode_objek_pajak = val.objek_pajak;
      this.data.dtl_manifestOri[index2].kode_setoran_pajak = val.kode_setoran_pajak;
      this.data.dtl_manifestOri[index2].dpp_value = val.dpp_value;
    },
    handleCancelTrans(){
      this.loading.cancel = true;
      let data = new FormData();
        data.append("tlc", this.getAuth.username);
        data.append("id_manifest",this.data.manifest.id_manifest);
        data.append("jenis_trans",'adendum');
        data.append("code_trans", this.data.manifest.no_adendum);
        let code = this.data.manifest.no_adendum.split("/");
        data.append("kode_project", code[2]);
      this.asyncAxiosPost("main/cancel_transaction", "formdata", this.getAuth, data)
        .then(() => {
          this.displayMessage("success-cancel");
          this.loading.cancel = false;

          this.$router.go(-1);
        })
        .catch((err) => {
          this.loading.cancel = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
    },
  },
  mounted() {
    this.fetchManifest();
    // this.fetchShipment();
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageReturn", this.handleAction);
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageReturn", this.handleAction);
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
        this.reqFileTf = true;
        this.search = "";
      }
    },
  },
};
</script>

<style></style>
